import React, { useRef } from "react";
import PropTypes from "prop-types";
import { useField } from "formik";
import { TextInputButton } from "@qgiv/core-donor";

const GoalInput = ({
    id,
    name = "",
    settings,
    allowsZeroDollarValue = false,
}) => {
    const [field, meta, helper] = useField({
        name,
        value: "",
    });
    // Use the error and touched data that is used to display standard Formik
    // errors and transform this data into the type of input that
    // TextInputButton expects
    const includesTeam = name.toLowerCase().includes("team");
    const txtInputBtnRef = useRef();
    const goalLabel = "Your Fundraising Goal";
    const teamGoalLabel = "Team Fundraising Goal";
    const shouldDisplayError = meta.error && meta.touched;
    const errorText = meta.error;
    const fieldProps = {
        ...field,
        "aria-required": "true",
        id,
        onChange: (e, QMask) => {
            const currentTarget = QMask.el.input;
            // eslint-disable-next-line no-shadow
            const { name } = currentTarget;
            const value = QMask.unmaskedValue;
            field.onChange({ target: { name, value } });
        },
        handleBlur: () => {
            helper.setTouched(true);
        },
        labelText: includesTeam ? teamGoalLabel : goalLabel,
        type: "currency",
        settings,
        error: shouldDisplayError,
        errorText,
        txtInputBtnRef,
        selectable: false,
        allowsZeroDollarValue,
        alwaysDisplayPlaceholder: true,
        centeredDisplay: false,
    };
    return <TextInputButton {...fieldProps} />;
};

GoalInput.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string,
    settings: PropTypes.shape({}).isRequired,
    allowsZeroDollarValue: PropTypes.bool,
};

export default GoalInput;
